import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-md-6 mx-auto" }
const _hoisted_2 = { class: "dl-horizontal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("dt", null, "ID", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("dt", null, "Total Level", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("dt", null, "Gacha Weights", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("dt", null, "Interactive Seconds", -1)
const _hoisted_7 = { class: "card-footer bg-white border border-light" }
const _hoisted_8 = { class: "col text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_simple_table = _resolveComponent("app-simple-table")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_openBlock(), _createBlock(_component_app_card, {
    class: "col-lg-8 mx-auto",
    label: "Picword Pet Detail "
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("dl", _hoisted_2, [
          _createElementVNode("tr", null, [
            _hoisted_3,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.id), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_4,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.totalLevel), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_5,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.gachaWeights), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_6,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.interactiveSeconds), 1)
          ])
        ])
      ]),
      _createVNode(_component_app_simple_table, {
        items: _ctx.model.rewardList,
        fields: [
                'level',
                'requiredExperience',
                'creditReward',
                'heartReward',
                'boosterTypeRewardName',
                'boosterQuantityReward'
            ]
      }, null, 8, ["items"]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_app_button, {
            name: "Edit",
            icon: "fa-edit",
            theme: "info",
            to: { name: _ctx.ROUTE_NAME_PICWORD.PET.EDIT, params: { id: _ctx.model.id } }
          }, null, 8, ["to"]),
          _createVNode(_component_app_button, {
            name: "Delete",
            icon: "fa-trash-alt",
            theme: "danger",
            onClick: _withModifiers(_ctx.actions.remove, ["prevent"])
          }, null, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }))
}